/**
 *
 * DialogWrapper
 *
 */

import { Dialog, PaperProps } from '@mui/material';
import clsx from 'clsx';
import * as React from 'react';
import { DialogClasses } from '@mui/material/Dialog/dialogClasses';
import { Breakpoint } from '@mui/system';
import { makeThemeStyle } from '../../../styles/makeThemeStyle';

const useStyles = makeThemeStyle(_ => ({
  paper: {
    minWidth: 500,
  },
}));

interface DialogWrapperStyleProps {
  overrideDialogStyle?: string;
  overrideDialogClasses?: Partial<DialogClasses>;
}

interface DialogWrapperProps extends DialogWrapperStyleProps {
  open: boolean;
  onClose: (event: React.MouseEvent<{}>, reason?: string) => void;
  onDialogClick?: (event: React.MouseEvent<{}>) => void;
  paperComponent?: React.JSXElementConstructor<PaperProps>;
  maxWidth?: Breakpoint | false;
}

export const DialogWrapper = (
  props: React.PropsWithChildren<DialogWrapperProps>,
) => {
  const styles = useStyles();
  const {
    open,
    onClose,
    onDialogClick,
    overrideDialogStyle,
    overrideDialogClasses,
    maxWidth,
    paperComponent,
    children,
  } = props;
  return (
    <Dialog
      className={clsx([overrideDialogStyle])}
      classes={
        overrideDialogClasses ?? {
          paper: styles.paper,
        }
      }
      open={open}
      onClose={onClose}
      onClick={onDialogClick ?? (e => e.stopPropagation())}
      PaperComponent={paperComponent}
      maxWidth={maxWidth}
    >
      {children}
    </Dialog>
  );
};
